let counter = 0;

export const getMenuItemId = () => counter++;

export const parseMenuResponse = ({ menuItems, ...other }) => {
    return {
        menuItems: parseMenuItems(menuItems),
        ...other
    };
};

export const parseMenuItems = (menuItems = []) => {
    return menuItems.map((menuItem) => ({
        ...menuItem,
        title: menuItem.title.replace('noname', ''),
        id: getMenuItemId(),
        ...menuItem.children?.length ? { children: parseMenuItems(menuItem.children) } : {}
    }));
};
